import websocket from "websocket";
import {
    isEmpty } from "lodash";
import {
  printDebugLog
} from "../constants/constant";

export function createCartWebSocket(url, onMessage, onOpen, onClose) {
    const socket = new websocket.w3cwebsocket(url);

    let heartbeatTimer;
    let missedPongs = 0;
    let intentionallyClosed = false;
    const MAX_MISSED_PONGS = 10;
    const HEARTBEAT_INTERVAL = 60000; // 60 seconds

    // Dashboard cleanup calls `socket.close()`. Mark only that public close as
    // intentional; a server/error/heartbeat close must still reconnect even
    // when the browser reports it as a clean close.
    const nativeClose = socket.close.bind(socket);
    const closeForReconnect = () => nativeClose();
    socket.close = (...args) => {
        intentionallyClosed = true;
        return nativeClose(...args);
    };

    const startHeartbeat = () => {
        heartbeatTimer = setInterval(() => {
            if (socket.readyState === 1) {
                // Send heartbeat ping
                socket.send(JSON.stringify({ message: "SNP_A2Z_PING" }));
                missedPongs++;
            }

            // If missed too many → reconnect
            if (missedPongs >= MAX_MISSED_PONGS) {
                console.warn("SNP_WEBSOCKET: Missed PONGs.. Forcing reconnect...");
                clearInterval(heartbeatTimer);
                closeForReconnect();
            }
        }, HEARTBEAT_INTERVAL);
    };

    socket.onopen = () => {
        missedPongs = 0;
        startHeartbeat();
        onOpen && onOpen();
    };

    socket.onmessage = (event) => {
        const msg = event.data;
        printDebugLog("SNP_WEBSOCKET: pong message: ", msg);
        // Heartbeat response
        if (msg?.includes("SNP_A2Z_PONG")) {
            missedPongs = 0; // Reset missed count
            return;
        }

        if (!isEmpty(msg) && msg.includes(":")) {
            const obj = JSON.parse(msg);
            onMessage && onMessage(obj);
        }
    };

    socket.onerror = () => {
        console.warn("SNP_WEBSOCKET: WS Error");
        closeForReconnect();
    };

    socket.onclose = (event) => {
        clearInterval(heartbeatTimer);

        if (intentionallyClosed) {
            console.log("SNP_WEBSOCKET: Intentional close, skip reconnect");
            return;
        }

        console.warn("SNP_WEBSOCKET: Connection closed, reconnecting", event.code);
        onClose && onClose();
    };
    return socket;
}
